export enum LanguageCodeEnum {
  SRB = 'srb',
  ENG = 'eng',
  PRT = 'prt',
  VNM = 'vnm'
}

/** Mirrors the backend's FeatureCode. Features are toggled per kindergarten. */
export enum FeatureCode {
  COMMENT_POST = 'COMMENT_POST',
  ENTER_ATTENDANCE_TIME = 'ENTER_ATTENDANCE_TIME',
  COMMENT_MEDIA = 'COMMENT_MEDIA',
  LIKE_MEDIA = 'LIKE_MEDIA',
  DOWNLOAD_MEDIA = 'DOWNLOAD_MEDIA',
  MULTIPLE_ATTACHMENT_UPLOAD = 'MULTIPLE_ATTACHMENT_UPLOAD',
  INVOICING = 'INVOICING'
}

export enum LanguageCodeDisplayEnum {
  SRB = 'Srb',
  ENG = 'Eng',
  PRT = 'Prt',
  VNM = 'Vnm'
}

export enum GeneralStatusEnum {
  ACTIVE = 'Active',
  INACTIVE = 'Inactive'
}

export enum UserStatusEnum {
  ACTIVE = 'Active',
  INACTIVE = 'Inactive'
}

export enum ActionMode {
  CREATE = 'create',
  EDIT = 'edit',
  DETAILS = 'details'
}

export enum KindergartenDetailsTabs {
  LocationsAndGroups,
  Teachers,
  Children,
  Parents,
  EventConfiguration
}

/** Sections of the billing setup page, under Finance. */
export enum BillingSetupSubTab {
  Settings,
  Items,
  Schemes
}
export enum GroupDetailsTabs {
  Teachers,
  Children,
  EventConfiguration
}
export enum SortOrderEnum {
  ASC = 'asc',
  DESC = 'desc'
}

export enum CreatePostTypeEnum {
  TEACHER = 'Teacher',
  ADMIN = 'Admin'
}

export enum ImportResultStatus {
  SUCCESS,
  WARNING
}

export enum CreateImportUserTypeEnum {
  TEACHER = 'Teacher',
  PARENT = 'Parent'
}

export enum ImportUserType {
  TEACHER = 'Teacher',
  PARENT = 'Parent',
  CHILDREN = 'Children'
}

export enum EventTitleEnum {
  MEALS = 'Meals',
  SLEEP = 'Sleep',
  TOILET = 'Toilet',
  MAIN_ACTIVITY = 'Main Activity',
  ADDITIONAL_ACTIVITIES = 'Additional Activities',
  CHILD_INTERACTION = `Child's Interaction`,
  OTHER_KIDS = 'Other kids',
  MOOD = 'Mood'
}

export type TranslatedString = Record<LanguageCodeEnum, string>;

export const EVENT_TITLE_TRANSLATIONS: Record<EventTitleEnum, TranslatedString> = {
  [EventTitleEnum.MEALS]: { eng: 'Meals', srb: 'Hrana', prt: 'Refeições', vnm: 'Bữa ăn' },
  [EventTitleEnum.SLEEP]: { eng: 'Sleep', srb: 'Spavanje', prt: 'Sono', vnm: 'Giấc ngủ' },
  [EventTitleEnum.TOILET]: { eng: 'Toilet', srb: 'Toalet', prt: 'Banheiro', vnm: 'Vệ sinh' },
  [EventTitleEnum.MAIN_ACTIVITY]: {
    eng: 'Main Activity',
    srb: 'Glavna aktivnost',
    prt: 'Atividade Principal',
    vnm: 'Hoạt động chính'
  },
  [EventTitleEnum.ADDITIONAL_ACTIVITIES]: {
    eng: 'Additional Activities',
    srb: 'Ostale aktivnosti',
    prt: 'Atividades Adicionais',
    vnm: 'Hoạt động bổ sung'
  },
  [EventTitleEnum.CHILD_INTERACTION]: {
    eng: `Child's Interaction`,
    srb: 'Uključenost u igru',
    prt: 'Interação da Criança',
    vnm: 'Tương tác của bé'
  },
  [EventTitleEnum.OTHER_KIDS]: {
    eng: 'Other kids',
    srb: 'Prihvaćenost',
    prt: 'Outras crianças',
    vnm: 'Các bé khác'
  },
  [EventTitleEnum.MOOD]: { eng: 'Mood', srb: 'Raspoloženje', prt: 'Humor', vnm: 'Tâm trạng' }
};

export enum EventFormStep {
  GroupAndEventSelectStep,
  EventSetupStep,
  ReviewStep
}
